<div class="spa-autocomplete-search">
  <div
    #autocompleteOrigin="cdkOverlayOrigin"
    cdkOverlayOrigin
    class="spa-autocomplete-search-input-container"
    data-testid="search_field"
    [class.searching]="isSearching"
  >
    <chd-text-input
      #searchInput
      inputId="guest-input-search"
      placeholder="{{ 'placeholder.enter-at-least-3-chars' | transloco }}"
      [icon]="icon()"
      [label]="label()"
      [readonly]="isReadOnly()"
      [required]="isRequired"
      [value]="searchTerm() ?? ''"
      (enterPressed)="enterPressed()"
      (focused)="onFocus()"
      (valueChange)="onInputChange($event)"
    />
    <chd-progress-spinner class="pr-2" size="small" [ariaLabel]="'loading-text.home.search' | transloco" />
  </div>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayMatchWidth]="true"
    [cdkConnectedOverlayOpen]="localRows() !== null"
    [cdkConnectedOverlayOrigin]="autocompleteOrigin"
    [cdkConnectedOverlayPositions]="overlayPositions"
    [cdkConnectedOverlayPush]="true"
    [cdkConnectedOverlayViewportMargin]="8"
    (overlayKeydown)="onOverlayKeydown($event)"
    (overlayOutsideClick)="onOverlayOutsideClick($event, autocompleteOrigin.elementRef.nativeElement)"
  >
    @if (localRows(); as rows) {
      <div class="spa-autocomplete-search-autocomplete-container" tabindex="0">
        @if (rows.length) {
          <div class="spa-autocomplete-search-results-container">
            @for (row of rows; track row; let i = $index) {
              <div class="spa-autocomplete-search-results-row" data-testid="search_result">
                @if (checkboxSelectionType !== "none") {
                  <chd-checkbox
                    class="pr-3"
                    data-testid="search_result_selected_checkbox"
                    inputId="checkbox-{{ i }}"
                    [ariaLabel]="label()"
                    [checked]="row.isChecked"
                    [readonly]="row.alreadySelected"
                    (checkedChange)="onCheck(i)"
                  />
                }
                <div
                  class="spa-autocomplete-search-guest-container"
                  role="button"
                  [attr.aria-disabled]="row.alreadySelected"
                  [attr.tabindex]="row.alreadySelected ? -1 : 0"
                  [ngStyle]="{ cursor: row.alreadySelected ? 'default' : 'pointer' }"
                  (click)="onSelectSingleRowDirectly(row)"
                  (keydown.enter)="onSelectSingleRowDirectly(row)"
                  (keydown.space)="onSelectSingleRowDirectly(row); $event.preventDefault()"
                >
                  @for (column of columns; track column; let j = $index) {
                    <div
                      class="spa-autocomplete-search-cell pr-3"
                      id="autocomplete-cell-{{ i }}-{{ j }}"
                      [ngStyle]="{
                        width: column.widthInPercent ?? column.widthInPercent,
                      }"
                      lang="de"
                    >
                      {{ cellValue(row.data, column) }}
                      @if (getTemplate(column.key); as tpl) {
                        <ng-container *ngTemplateOutlet="tpl.template; context: { row }"></ng-container>
                      }
                    </div>
                  }
                </div>
              </div>
            }
          </div>
          @if (checkboxSelectionType !== "none") {
            <div class="spa-autocomplete-search-buttons">
              <chd-button
                class="mr-3"
                id="search-box-btn-cancel"
                variant="text"
                [label]="'label.button.cancel' | transloco"
                (clicked)="reset()"
              />
              <chd-button
                class="ml-3"
                id="search-box-btn-confirm"
                [disabled]="applyDisabled()"
                [label]="'label.button.ok' | transloco"
                (clicked)="applySelection()"
              />
            </div>
          }
        } @else {
          @if (!rows.length) {
            <div class="spa-autocomplete-search-no-results">
              {{ "empty-search-text.home.search" | transloco }}
            </div>
          }
        }
      </div>
    }
  </ng-template>
</div>
